import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { QnaheaderApi } from '../../lib/repository/qnaheader/qnaheader.api';

export const qnaheaderChatGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const qnaheaderApi = inject(QnaheaderApi);

  if (route.firstChild) {
    // ID 있으면 통과
    const id = route.firstChild.params['id'];

    if (id) {
      return true;
    }
  }

  const requestsId = route.queryParams['requestsId'];

  // 상담 ID 없으면 진입 불가
  if (!requestsId) {
    return false;
  }

  // 문의 정보 조회
  return qnaheaderApi
    .findPage({
      requestsId: requestsId,
    })
    .pipe(
      map((page) => {
        if (page.content.length > 0) {
          // 문의 정보 있으면 채팅 페이지로 이동
          return router.createUrlTree(['/message-chat', page.content[0].id], {
            queryParams: route.queryParams,
            queryParamsHandling: 'merge',
          });
        }

        return router.createUrlTree(['/message-chat', -1], {
          queryParams: route.queryParams,
          queryParamsHandling: 'merge',
        });
      }),
    );
};
